/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Kind_Failure_HintInputs */

const en_us2_workout_logging_kind_failure_hint = /** @type {(inputs: Workout_Logging_Kind_Failure_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taken until not one more rep would go. Counts as work.`)
};

const pt_br2_workout_logging_kind_failure_hint = /** @type {(inputs: Workout_Logging_Kind_Failure_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feita até não sair mais nenhuma repetição. Conta como trabalho.`)
};

const es_419_workout_logging_kind_failure_hint = /** @type {(inputs: Workout_Logging_Kind_Failure_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hecha hasta que no sale ni una repetición más. Cuenta como trabajo.`)
};

const pt_pt2_workout_logging_kind_failure_hint = /** @type {(inputs: Workout_Logging_Kind_Failure_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feita até não sair nem mais uma repetição. Conta como trabalho.`)
};

const fr_fr2_workout_logging_kind_failure_hint = /** @type {(inputs: Workout_Logging_Kind_Failure_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jusqu'à ne plus pouvoir faire une répétition. Compte comme travail.`)
};

const de_de2_workout_logging_kind_failure_hint = /** @type {(inputs: Workout_Logging_Kind_Failure_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgeführt, bis keine Wiederholung mehr ging. Zählt als Arbeitssatz.`)
};

const it_it2_workout_logging_kind_failure_hint = /** @type {(inputs: Workout_Logging_Kind_Failure_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portata finché non esce più nemmeno una ripetizione. Conta come lavoro.`)
};

/**
* | output |
* | --- |
* | "Taken until not one more rep would go. Counts as work." |
*
* @param {Workout_Logging_Kind_Failure_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_kind_failure_hint = /** @type {((inputs?: Workout_Logging_Kind_Failure_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Kind_Failure_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_kind_failure_hint(inputs)
	if (locale === "es-419") return es_419_workout_logging_kind_failure_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_kind_failure_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_kind_failure_hint(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_kind_failure_hint(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_kind_failure_hint(inputs)
	return en_us2_workout_logging_kind_failure_hint(inputs)
});
export { workout_logging_kind_failure_hint as "workout-logging.kind_failure_hint" }